<template>
  <div>
    <v-btn-toggle
      v-model="toggleExclusive"
      class="mode-toggle"
      active-class="mode-toggle--active"
      color="white"
      borderless
      mandatory
    >
      <v-btn
        v-for="button in toggleButtons"
        :key="button.title"
        :title="button.title"
        @click.stop="changeViewMode(button.viewMode)"
      >
        <v-icon>{{ button.icon }}</v-icon>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import { viewModes } from '@/utils/mappers.js';

export default {
  name: 'HeaderToggles',
  props: {
    homeViewMode: {
      type: String,
      default: 'CARD',
    },
  },
  computed: {
    toggleButtons() {
      return [
        {
          title: 'Histórico de Pautas',
          viewMode: viewModes.CARD,
          icon: 'mdi-file-document-outline',
        },
        {
          title: 'Tempo Real',
          viewMode: viewModes.TABLE,
          icon: 'lightbulb_outline',
        },
        {
          title: 'Contatos',
          viewMode: viewModes.CONTACT,
          icon: 'mdi-account-circle-outline',
        },
        {
          title: 'Espelhos',
          viewMode: viewModes.MIRROR,
          icon: 'mdi-video-outline',
        },
        {
          title: 'Histórico de Espelhos',
          viewMode: viewModes.MIRROR_HISTORIC,
          icon: 'mdi-clock-outline',
        },
      ];
    },
  },

  methods: {
    changeViewMode(viewMode) {
      return this.$emit('changeViewMode', viewMode);
    },
    initToggleExclusive() {
      this.toggleExclusive = {
        CARD: 0,
        TABLE: 1,
        CONTACT: 2,
        MIRROR: 3,
        MIRROR_HISTORIC: 4,
      }[this.homeViewMode];
    },
  },

  created() {
    this.initToggleExclusive();
  },

  data() {
    return {
      viewModes,
      toggleExclusive: 0,
    };
  },
};
</script>
